<template>
  <el-config-provider :locale="langStore.lang">
    <div class="main" v-if="userStore.token" ref="mainRef">
      <leftChat ref="leftChatRef" />
      <main
        class="content-main"
        :style="{ width: `calc(100vw - ${mainWidth}px - ${collapseMenu}rem)` }"
      >
        <Header @toggleCollapse="toggleCollapse" :isCollapse="isCollapse" />
        <RouterView />
      </main>
    </div>
    <Login v-if="!userStore.token" />

    <ChatTranslate v-if="changeStore.visible" />
    <!-- 截图功能 -->
    <CropperVue v-if="cropperStore.visible" />
  </el-config-provider>
</template>

<script lang="ts" setup>
import {
  getCurrentInstance,
  ref,
  createApp,
  onMounted,
  watchEffect,
  onBeforeMount,
  watch
} from 'vue'
import { RouterView, useRouter } from 'vue-router'
import leftChat from './views/customer/component/left-chat.vue'
import Header from './views/header-nav/index.vue'

import {
  useUserStore,
  useWebSocketStore,
  useLangStore,
  useTranslatChangeStore,
  useCropperStore,
  useSliderStore
} from './stores'
import Login from './views/login/index.vue'
import { useI18n } from 'vue-i18n'
import ChatTranslate from '@/components/chat-translate/index.vue'
import CropperVue from '@/components/cropper/index.vue'
import { isSupportedNotification } from '@/utils/check'
import { loginOut } from '@/server/employee_request'
import { ElMessage, ElMessageBox } from 'element-plus'
import Popover from '@/components/popover/index.vue'
import Tabs from '@/components/tabs/index.vue'
import Dialog from '@/components/dialog/index.vue'
import moment from 'moment'
import '@/assets/msg.scss'
import '@/assets/popover.scss'
import router, { setupRoutes } from './router'
import { Mounted } from '@icon-park/vue-next'
const userStore = useUserStore()
const webSocketStore = useWebSocketStore()
const langStore = useLangStore()
const changeStore = useTranslatChangeStore()
const cropperStore = useCropperStore()
const { locale } = useI18n()
let beforeunloadData: any
const showMenu = ref(false)
const app = createApp({})
app.component('Popover', Popover)

const mainWidth = ref(0)
const mainRef = ref(null)
// let routerpath = JSON.parse(localStorage.getItem('routerpath'))?.to
onMounted(async () => {
  await setupRoutes()
})
const collapseMenu = ref(0)
const leftChatRef = ref()
const isCollapse = ref(true)
const toggleCollapse = () => {
  isCollapse.value = leftChatRef.value.toggleCollapseMenu()
}
watch(
  () => useSliderStore().isCollapse,
  (newVal, oldVal) => {
    if (newVal == false) {
      collapseMenu.value = 12
    } else {
      collapseMenu.value = 0
    }
  }
)
watchEffect(() => {
  const updateMainWidth = () => {
    if (mainRef.value) {
      mainWidth.value = mainRef.value.offsetWidth
    }
  }

  updateMainWidth()

  const resizeObserver = new ResizeObserver((entries) => {
    for (let entry of entries) {
      mainWidth.value = entry.contentRect.width
    }
  })

  if (mainRef.value) {
    resizeObserver.observe(mainRef.value)
  }

  return () => {
    resizeObserver.disconnect()
  }
})

//创建国际化实例
//@ts-ignore
// eslint-disable-next-line no-unsafe-optional-chaining
const { $t } = getCurrentInstance()?.appContext.config.globalProperties
window.ononline = function () {
  webSocketStore.setOnline(true)
  const status = webSocketStore.webSokcetStatus()
  if (status !== WebSocket.OPEN || status !== WebSocket.CONNECTING) {
    webSocketStore.connect()
    webSocketStore.keepHeart()
  }
}
window.onbeforeunload = function () {
  beforeunloadData = new Date().getTime()
  useRouter().push(routerpath.path)
}
window.onunload = function () {
  const nowT = new Date().getTime()
  if (nowT - beforeunloadData <= 5) {
    loginOut()
    userStore.loginOut()
  }
}
window.onresize = function () {
  if (window.innerWidth <= 768) {
    useUserStore().setIsPcParam(false)
  } else {
    useUserStore().setIsPcParam(true)
  }
}

//防止浏览器刷新，导致语言改变行为
locale.value = userStore.locale
const setLanguage = () => {
  const language = userStore.locale || window.navigator.language
  if (language && language.indexOf('zh') > -1) {
    moment.locale('zh')
    locale.value = 'zh'
  } else {
    moment.locale(language)
    locale.value = language
  }
}
setLanguage()
isSupportedNotification(
  $t('t_attention'),
  $t('t_user_refused_attention'),
  $t('t_browser_not_supported')
)
</script>
<style scoped>
@media screen and (min-width: 996px) {
  .main {
    height: 100vh;
    overflow-y: hidden;
    display: flex;
    flex-direction: row;
    position: relative;
    background-color: #f4f4f5;;
  }
}
@media screen and (max-width: 996px) {
  .main {
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    position: relative;
    text-align: center;
    height: 100vh;
    width: 100vw;
    touch-action: pan-y;
    overflow: hidden;
  }
}
.menuClass {
  display: flex;
  flex-direction: row;
  align-items: center;
}
header {
  line-height: 1.5;
  max-height: 100vh;
}
.content-main {
  flex: 1;
  width: calc(100vw - 3.3vw);
  height: 100%;
  overflow: hidden;
}
@media (max-width: 768px) {
  .content-main {
    width: 100vw !important;
  }
}
.logo {
  display: block;
  margin: 0 auto 2rem;
}

nav {
  width: 100%;
  font-size: 12px;
  text-align: center;
  margin-top: 2rem;
}

nav a.router-link-exact-active {
  color: var(--color-text);
}

nav a.router-link-exact-active:hover {
  background-color: transparent;
}

nav a {
  display: inline-block;
  padding: 0 1rem;
  border-left: 1px solid var(--color-border);
}

nav a:first-of-type {
  border: 0;
}
:deep(.el-input__wrapper) {
  /* border-radius: 15px; */
  /* background: #f1f1f1; */
  border-radius: 5px;
  background-color: #fff;
}
::v-deep .el-select__wrapper {
  border-radius: 5px;
}
:deep(.el-input .el-input__count .el-input__count-inner) {
  /* background: #f1f1f1; */
  background-color: #fff;
}
:deep(.box-card) {
  border-radius: 8px !important;
  box-shadow: none !important;
  border: none;
}
.el-select .el-input.is-focus ::v-deep .el-input__inner {
  outline: none !important;
  box-shadow: none;
}
:focus-visible {
  outline: none !important;
}
@media (min-width: 1024px) {
  header {
    display: flex;
    place-items: center;
    padding-right: calc(var(--section-gap) / 2);
  }

  .logo {
    margin: 0 2rem 0 0;
  }

  header .wrapper {
    display: flex;
    place-items: flex-start;
    flex-wrap: wrap;
  }

  nav {
    text-align: left;
    margin-left: -1rem;
    font-size: 1rem;
    padding: 1rem 0;
    margin-top: 1rem;
  }
}

:deep(.el-notification__group) {
  width: 100% !important;
}
:deep(.el-select__input) {
  /* width: 100% !important; */
}

:deep(.el-table__border-left-patch) {
  background-color: white !important;
}
:deep(.el-table--border:after) {
  background-color: transparent !important;
}
:deep(.el-table__body .el-table__cell) {
  border-left: 1px solid transparent !important;
  border-right: 1px solid transparent !important;
}

:deep(.el-table__inner-wrapper:before) {
  background-color: transparent;
}
:deep(.el-table--border th.el-table__cell) {
  border: 1px solid white;
}
</style>
